export const getNumbersAfterSites = (url: string) => {
  const match = url.match(/\/sites\/(\d+)/);
  if (match) {
    return match[1];
  } else {
    return "";
  }
};

export const getNumbersAfterEditCamera = (url: string) => {
  const match = url.match(/\/editcamera\/(\d+)/);
  if (match) {
    return match[1];
  } else {
    return "";
  }
};

/**
 * The camera the Edit Camera page is showing, from the URL (ENG-2680).
 *
 * Saves must use this, not localStorage.currentCameraId: the Next arrow used
 * to leave that on the previous camera, so switching a camera's Active off
 * after pressing Next deactivated the camera you came from. Falls back to
 * localStorage only when the URL has no camera id.
 */
export const editCameraIdFromUrl = (
  url: string = window.location.href
): string =>
  getNumbersAfterEditCamera(url) || localStorage.currentCameraId || "";

/**
 * Point the page's localStorage at the camera now in the URL, as the first
 * load and the Previous arrow do: General Info tab, this camera's id.
 */
export const recordEditCameraOpened = (url: string = window.location.href) => {
  localStorage.setItem("editCamerActiveTab", "one");
  const cameraId = getNumbersAfterEditCamera(url);
  if (cameraId) localStorage.setItem("currentCameraId", cameraId);
};
